export default {
    methods: {
        convertCurrentValue(value) {
            return Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
            }).format(value)
        },
        convertDecimalValue(value) {
            return Intl.NumberFormat('pt-BR', {
                style: 'decimal',
            }).format(value)
        },

        convertDate(v) {
            if (v) {
                v = v.replace("-", "").replace("-", "");
                let year = v.substring(0, 4);
                let month = v.substring(4, 6);
                let day = v.substring(6, 8);
                return `${day}/${month}/${year}`;
            } else {
                return false;
            }
        },
        convertDateTime(v) {
            if (v) {
                v = v.replace('-', '').replace('-', '');
                let year = v.substring(0, 4);
                let month = v.substring(4, 6);
                let day = v.substring(6, 8);
                let hour = v.substring(9, 11);
                let min = v.substring(12, 14);
                return `${day}/${month}/${year} ${hour}:${min}`;
            } else {
                return false;
            }
        },
        calcValue() {
            if (
                parseFloat(this.data.item_price) > 0 &&
                parseFloat(this.data.item_amount) > 0
            ) {
                this.data.item_total_bidding_price =
                    parseFloat(this.convertDecimalNumber(this.data.item_price)) *
                    parseFloat(this.data.item_amount);
            }
        },
        convertDecimalNumber(n) {
            let number = n;
            number = number
                .replace(",", "")
                .replace(".", "")
                .replace(".", "");
            return number;
        },
        convertDecimalNumberII(n) {
            let number = n;
            number = number
                .replace(",", ".")
            return number;
        },
        convertDecimalNumberIII(n) {
            let number = n;
            number = number.replace(/\./g, ""); //retira o ponto do valor entrado
            number = number.replace(",", "."); //troca a vírgula por 
            return number;
        },
        realMask(value) {
            if (value && parseFloat(value) > 0) {
                value = value.replace(/\D/g, ""); // permite digitar apenas numero
                value = value.replace(/(\d{1})(\d{14})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
                value = value.replace(/(\d{1})(\d{11})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
                value = value.replace(/(\d{1})(\d{8})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
                value = value.replace(/(\d{1})(\d{5})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
                value = value.replace(/(\d{1})(\d{1,2})$/, "$1,$2"); // coloca virgula antes dos ultimos 2 digitos
                return value;
            } else {
                return 0;
            }
        },
        realMaskII(value) {
            if (value && parseFloat(value) > 0) {
                value = value.replace(/\D/g, ""); // permite digitar apenas numero
                value = value.replace(/(\d{1})(\d{15})$/, "$1.$2"); // coloca ponto antes dos ultimos digitos
                value = value.replace(/(\d{1})(\d{12})$/, "$1.$2"); // coloca ponto antes dos ultimos 11 digitos
                value = value.replace(/(\d{1})(\d{9})$/, "$1.$2"); // coloca ponto antes dos ultimos 8 digitos
                value = value.replace(/(\d{1})(\d{6})$/, "$1.$2"); // coloca ponto antes dos ultimos 5 digitos
                value = value.replace(/(\d{1})(\d{1,3})$/, "$1,$2"); // coloca virgula antes dos ultimos 2 digitos
                return value;
            } else {
                return 0;
            }
        },
        formatDateBr(date) {
            return date
                .substr(0, 10)
                .split("-")
                .reverse()
                .join("/");
        },

        checkAuth() {
            if (localStorage.getItem("token")) {
                this.$router.push("/dashboard");
            } else {
                this.$router.push("/login");
            }
        }
    }
}